import React from "react";

const TermsAndConditions = () => (
  <div className="privacy-policy-container rtl">
    <h1>תנאי שימוש</h1>
    <p>עודכן לאחרונה: 2 ביוני 2025</p>
    <p>אנא קרא בעיון את תנאי השימוש הבאים לפני השימוש בשירות שלנו.</p>
    <h2> פרשנות והגדרות</h2>
    <h3>פרשנות</h3>
    <p>
      למילים שהאות הראשונה שלהן אות גדולה יש משמעויות מוגדרות בתנאים הבאים.
      להגדרות הבאות תהיה אותה משמעות בין אם הן מופיעות ביחיד או ברבים.
    </p>
    <h3>הגדרות</h3>
    <p>למטרות מדיניות פרטיות זו:</p>
    <ul>
      <li>
        <strong>שותף</strong> - פירושו ישות השולטת, נשלטת על ידי או נמצאת תחת
        שליטה משותפת עם צד, כאשר "שליטה" משמעותה בעלות על 50% או יותר מהמניות,
        זכויות הון או ניירות ערך אחרים הזכאים להצביע לבחירת דירקטורים או רשות
        ניהולית אחרת.
      </li>
      <li>
        <strong>אפליקציה</strong> - אפליקציית Rumiz, התוכנה המסופקת על ידי
        החברה.
      </li>
      <li>
        <strong>החברה</strong> - (המוכרת גם כ"החברה", "אנחנו", "אותנו" או "שלנו"
        בהסכם זה) מתייחסת ל-Rumiz בע"מ.
      </li>
      <li>
        <strong>מדינה</strong> - מתייחסת לישראל.
      </li>
      <li>
        <strong>מכשיר</strong> - פירושו כל מכשיר שיכול לגשת לשירות כגון מחשב,
        טלפון סלולרי או טאבלט דיגיטלי.
      </li>
      <li>
        <strong>מידע אישי</strong> - כל מידע שמזהה אותך באופן אישי.
      </li>
      <li>
        <strong>שירות</strong> - האפליקציה.
      </li>
      <li>
        <strong>תנאי שימוש</strong> - (המוכרים גם כ"תנאים") פירושם תנאי שימוש
        אלה המהווים את ההסכם המלא בינך לבין החברה בנוגע לשימוש בשירות.כל אדם או
        חברה המעבדים נתונים עבור החברה.
      </li>
      <li>
        <strong>נתוני שימוש</strong> - נתונים הנאספים אוטומטית בעת השימוש
        בשירות.
      </li>
      <li>
        <strong>אתה</strong> - האדם המשתמש בשירות או החברה/ישות משפטית בשמה אתה
        פועל.
      </li>
    </ul>
    <h2>הכרה</h2>
    <p>
      אלה הם תנאי השימוש המסדירים את השימוש בשירות זה ובהסכם הפועל בינך לבין
      החברה. תנאי שימוש אלה מפרטים את הזכויות והחובות של כל המשתמשים בנוגע
      לשימוש בשירות.
    </p>
    <p>
      הגישה והשימוש שלך בשירות מותנים בקבלה ובציות שלך לתנאי שימוש אלה. תנאי
      שימוש אלה חלים על כל המבקרים, המשתמשים ואחרים הניגשים או משתמשים בשירות.
    </p>
    <p>
      על ידי גישה או שימוש בשירות אתה מסכים להיות מחויב לתנאי שימוש אלה. אם אינך
      מסכים עם חלק כלשהו מתנאי שימוש אלה, אז אינך רשאי לגשת לשירות.
    </p>
    <p>
      אתה מצהיר שאתה מעל גיל 18. החברה אינה מתירה לאלה שהם מתחת לגיל 18 להשתמש
      בשירות.
    </p>
    <p>
      הגישה והשימוש שלך בשירות מותנים גם בקבלה ובציות שלך למדיניות הפרטיות של
      החברה. מדיניות הפרטיות שלנו מתארת את המדיניות והנהלים שלנו לגבי איסוף,
      שימוש וגילוי של המידע האישי שלך כאשר אתה משתמש באפליקציה או באתר האינטרנט
      ומספרת לך על זכויות הפרטיות שלך וכיצד החוק מגן עליך. אנא קרא את מדיניות
      הפרטיות שלנו בקפידה לפני השימוש בשירות שלנו.
    </p>

    <h2> קישורים לאתרים אחרים</h2>
    <p>
      השירות שלנו עשוי להכיל קישורים לאתרי אינטרנט או שירותים של צד שלישי שאינם
      בבעלות או בשליטת החברה.
    </p>

    <p>
      לחברה אין שליטה ואינה נוטלת אחריות על התוכן, מדיניות הפרטיות או
      הנהלים של כל אתר אינטרנט או שירות של צד שלישי. אתה מאשר ומסכים גם כי החברה
      לא תהיה אחראית או חייבת, במישרין או בעקיפין, לכל נזק או אובדן שנגרם או
      נטען כי נגרם על ידי או בקשר עם השימוש או ההסתמכות על כל תוכן, סחורות או
      שירותים הזמינים באמצעות או דרך כל אתרי אינטרנט או שירותים כאלה.
    </p>

    <p>
      אנו ממליצים לך בחום לקרוא את תנאי השימוש ומדיניות הפרטיות של כל אתר
      אינטרנט או שירות של צד שלישי שאתה מבקר בו.
    </p>

    <h2> סיום</h2>
    <p>
      אנו עשויים לסיים או להשעות את הגישה שלך מיידית, ללא הודעה מוקדמת או חבות,
      מכל סיבה שהיא, כולל מבלי להגביל אם תפר תנאי שימוש אלה.
    </p>
    <p>עם הסיום, זכותך להשתמש בשירות תפסיק מיידית.</p>

    <h2> הגבלת אחריות</h2>

    <p>
      במידה המותרת על פי החוק החל, בשום מקרה החברה או ספקיה לא יהיו אחראים
      לנזקים מיוחדים, מקריים, עקיפים או תוצאתיים כלשהם (כולל, אך לא מוגבל לנזקים
      בגין אובדן רווחים, אובדן נתונים או מידע אחר, עבור הפרעה עסקית, לפגיעה
      אישית, אובדן פרטיות הנובעים מתוך או בכל דרך הקשורה לשימוש או אי יכולת
      להשתמש בשירות, תוכנה של צד שלישי ו/או חומרה של צד שלישי המשמשת עם השירות,
      או אחרת בקשר עם כל הוראה בתנאים אלה), גם אם החברה או כל ספק יעצו לאפשרות
      של נזקים כאלה וגם אם התרופה נכשלת במטרתה העיקרית.
    </p>
    <p>
      מדינות מסוימות אינן מאפשרות את החרגת האחריות המשתמעת או הגבלת האחריות
      לנזקים מקריים או תוצאתיים, מה שאומר שחלק מההגבלות לעיל עשויות לא לחול.
      במדינות אלה, אחריותו של כל צד תהיה מוגבלת במידה המרבית המותרת על פי חוק.
    </p>

    <h2>כתב ויתור "as is" ו"כפי שזמין"</h2>
    <p>
      השירות מסופק לך "as is" ו"כפי שזמין" ועם כל הפגמים/הליקויים במידה ויש - ללא
      אחריות מכל סוג שהוא. במידה המירבית המותרת על פי החוק החל, החברה, בשמה ובשם
      שותפיה ובשם המורשים וספקי השירות שלה ושלהם, מתנערת במפורש מכל אחריות, בין
      אם מפורשת, משתמעת, חוקית או אחרת, ביחס לשירות, כולל כל אחריות משתמעת
      לסחירות, התאמה למטרה מסוימת, כותרת ואי הפרה, ואחריות שעשויה לנבוע ממהלך
      עסקים, מהלך ביצוע, שימוש או נוהג מסחרי. מבלי להגביל את האמור לעיל, החברה
      אינה מספקת אחריות או התחייבות, ואינה מצהירה מכל סוג שהוא כי השירות יענה על
      הדרישות שלך, ישיג תוצאות מתוכננות כלשהן, יהיה תואם או יעבוד עם תוכנה,
      יישומים, מערכות או שירותים אחרים, יפעל ללא הפרעות, יעמוד בכל סטנדרט של
      ביצועים או אמינות או יהיה ללא שגיאות או שכל שגיאות או פגמים יכולים או
      יתוקנו.
    </p>
    <p>
      מבלי להגביל את האמור לעיל, לא החברה ולא איש מספקי החברה מצהירים או מבטיחים
      מכל סוג שהוא, במפורש או במשתמע: (i) באשר לפעולה או לזמינות של השירות, או
      למידע, תוכן וחומרים או מוצרים הכלולים בו; (ii) כי השירות יהיה ללא הפרעות
      או ללא שגיאות; (iii) באשר לדיוק, אמינות או עדכניות של מידע או תוכן כלשהו
      המסופק באמצעות השירות; או (iv) כי השירות, שרתיו, התוכן או דואר אלקטרוני
      שנשלח מאו בשם החברה הם ללא וירוסים, סקריפטים, סוסים טרויאניים, תולעים,
      תוכנות זדוניות, פצצות זמן או רכיבים מזיקים אחרים.
    </p>

    <p>
      תחומי שיפוט מסוימים אינם מאפשרים את החרגת סוגים מסוימים של אחריות או
      הגבלות על זכויות חוקיות ישימות של צרכן, כך שחלק או כל החרגות וההגבלות לעיל
      עשויות לא לחול עליך. אבל במקרה כזה ההחרגות וההגבלות המפורטות בסעיף זה
      יחולו במידה המרבית הניתנת לאכיפה על פי החוק החל.
    </p>

    <h2>חוק מנהל</h2>
    <p>
      חוקי המדינה, למעט כללי התנגשות החוקים שלה, ישלטו בתנאים אלה ובשימוש שלך
      בשירות. השימוש שלך באפליקציה עשוי להיות כפוף גם לחוקים מקומיים, מדינתיים,
      לאומיים או בינלאומיים אחרים.
    </p>

    <h2>יישוב סכסוכים</h2>
    <p>
      במידה ויש מחלוקת לגבי השירות, הנך מוזמן לפנות לתמיכה בכדי לפתור את המחלוקת.
      כל הליך משפטי, במידה ויתקיים מאחד הצדדים, יתקיים בבית המשפט בת״א.
    </p>

    <h2>פרשנות תרגום</h2>
    <p>
      תנאי שימוש אלה עשויים להיות מתורגמים אם הפכנו אותם זמינים עבורך בשירות
      שלנו. אתה מסכים כי הטקסט האנגלי המקורי יגבר במקרה של מחלוקת.
    </p>

    <h2>שינויים לתנאי שימוש אלה</h2>
    <p>
      אנו שומרים לעצמנו את הזכות, על פי שיקול דעתנו הבלעדי, לשנות או להחליף
      תנאים אלה בכל עת. שינויים אלה יהוו חלק בלתי נפרד מהאפליקציה.
    </p>

    <h2>צור קשר</h2>
    <p>
          באמצעות דואר אלקטרוני:{" "}
          <a href="mailto:rumiz.mail12@gmail.com">rumiz.mail12@gmail.com</a>
        </p>
        <p>התוכן פונה הן לגברים והן לנשים, ונכתב בלשון זכר לשם נוחות.</p>

    <p>© 2025 Rumiz בע״מ</p>
  </div>
);

export default TermsAndConditions;
